import React from 'react'
import styled from 'react-emotion'
import { colors } from '../../styles'

const Wrapper = styled('div')``

const Steps = styled('div')`
  overflow: hidden;
  margin: 20px 0 30px 0;
  display: flex;
  align-items: stretch;
  @media (max-width: 992px) {
    font-size: 1rem;
  }
`

const Step = styled('div')`
  padding: .5em;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  width: 33%;
  justify-content: center;
  color: ${props => props.active ? colors.tui_dark_blue : colors.tui_white};
  :last-of-type,
  :first-of-type {
    z-index: 0;
  }
  :first-of-type::after,
  :first-of-type::before,
  :last-of-type::after,
  :last-of-type::before {
    transform: skewX(0deg);
    margin-left: -10px;
    margin-right: -10px;
  }
  >div {
    font-weight: bold;
    display: inline-block;
    position: relative;
    z-index: 10;
  } 
  :before,
  :after {
    border-right: 4px solid  ${colors.tui_white};
    border-left: 4px solid  ${colors.tui_white};
    content: '';
    height: 50%;
    position: absolute;
    z-index: 1;
    display: block;
    left: 0;
    right: 0;
    background-color: ${props => props.active ? colors.tui_blue_25 : colors.tui_link_blue};
  }
  :after {
    bottom: 0;
    transform: skewX(-25deg);
  }
  :before {
    top: 0;
    transform: skewX(25deg);
  }

  @media (max-width: 992px) {
    width: calc(33%);
  }
`

export default ({ steps, currentStep, header }) => (
  <Wrapper>
    <h2>{header}</h2>
    <Steps>
      {steps.map((s, i) => <Step key={i} active={currentStep === i + 1}><div>{s}</div></Step>)}
    </Steps>
  </Wrapper>
)